var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{attrs:{"value":1,"unchecked-value":0},on:{"change":function($event){return _vm.updateValue()}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('span',{staticClass:"font-italic"},[_vm._v("Todos los nutrientes.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }